import { render, staticRenderFns } from "./WhiteboardTopToolbar.vue?vue&type=template&id=69bf7236&scoped=true&"
import script from "./WhiteboardTopToolbar.vue?vue&type=script&lang=js&"
export * from "./WhiteboardTopToolbar.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardTopToolbar.vue?vue&type=style&index=0&id=69bf7236&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf7236",
  null
  
)

export default component.exports